//eslint disable
import Girl from "../assets/images/girl.png";
import Image9 from "../assets/images/Gallery/img9.jpg";
import "../assets/styles/Home.css";
const Home = () => {
  return (
    <div className="bodyHome">
      <header>
        <div className="container header__container">
          <div className="header__left">
            <h1>We Produce Champions</h1>
            <p>
              Little Champ Football Academy create an optimal environment for
              young, which allows them to focus on the game, progress through
              continuous performance, communication, team building and schooling
              with other students with similar skills, potentials and ambitions.
            </p>
            <a href="#homeAbout" className="btn btn-primary">
              Get Started
            </a>
          </div>

          <div className="header__right">
            <div className="header__right-image">
              <img src={Girl} alt="Girl" />
            </div>
          </div>
        </div>
      </header>

      <div className="know">
        <div className="container header__container">
          <div className="header__right">
            <div className="header__right-image">
              <img src={Image9} alt="Ball" />
            </div>
          </div>
          <div className="header__left">
            <h1 id="homeAbout">Know About Us</h1>
            <p>
              This football academy provides professional with an established
              football excellence and education programme that will not only
              attract, develop and retain quality young players but also support
              your club in meeting core social responsibilities.
            </p>
            {/* <div className="aboutButton"> */}
            <a href="/about" className="football-link">
              Read More
            </a>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
